export const ACTIVITY_READING = "Reading this page…";
export const ACTIVITY_SUGGESTING = "Finding more questions…";
export const ACTIVITY_THINKING = "Thinking";
